import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function ZaiIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="303" height="258" viewBox="0 0 303 258" fill="none" {...props}>
      <path
        d="M159.231 0.608952L138.085 30.7023C134.831 35.4196 129.301 38.3476 123.445 38.3476H7.9513V0.446289C7.78864 0.608956 159.231 0.608952 159.231 0.608952Z"
        fill="white"
      />
      <path d="M302.866 0.608887L121.33 257.785H0.305908L181.842 0.608887H302.866Z" fill="white" />
      <path
        d="M143.941 257.785L165.25 227.529C168.503 222.812 174.034 219.884 179.89 219.884H295.221V257.785H143.941Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export default ZaiIcon;
